import styled, { css, CSSProperties } from 'styled-components';
import { cpdsMediaQueryVals } from 'components/common/cpds/token/shared/common';
import { ContainerWrapperProps } from 'components/common/cpds/cpds-grid-system/typings';

const handlePadding = (padding: string[] = [], index: number, defaultValue: string) => padding[index] || defaultValue;

export const ContainerWrapper = styled.div.attrs<ContainerWrapperProps>(({ dataCy, className, id }) => ({
  'data-cy': dataCy,
  className: className,
  ...(id && { id }),
}))<ContainerWrapperProps>`
  width: 100%;
  max-width: ${({ maxWidth }) => maxWidth || '1680px'};
  margin: 0 auto;

  /* Extra Large screens (default, ≥ 1680px) | default padding 0 56px*/
  padding-top: ${({ padding_xl }) => handlePadding(padding_xl, 0, '0px')};
  padding-right: ${({ padding_xl }) => handlePadding(padding_xl, 1, '56px')};
  padding-bottom: ${({ padding_xl }) => handlePadding(padding_xl, 2, '0px')};
  padding-left: ${({ padding_xl }) => handlePadding(padding_xl, 3, '56px')};

  /* Large screens (1280px - 1679px) | default padding 0 56px*/
  @media (max-width: ${cpdsMediaQueryVals.cpds_large_upper_limit}) and (min-width: ${cpdsMediaQueryVals.cpds_large_lower_limit}) {
    max-width: 1680px;
    padding-top: ${({ padding_lg }) => handlePadding(padding_lg, 0, '0px')};
    padding-right: ${({ padding_lg }) => handlePadding(padding_lg, 1, '56px')};
    padding-bottom: ${({ padding_lg }) => handlePadding(padding_lg, 2, '0px')};
    padding-left: ${({ padding_lg }) => handlePadding(padding_lg, 3, '56px')};
  }

  /* Medium screens (768px - 1279px) | default padding 0 40px */
  @media (max-width: ${cpdsMediaQueryVals.cpds_medium_upper_limit}) and (min-width: ${cpdsMediaQueryVals.cpds_medium_lower_limit}) {
    max-width: 100%;
    padding-top: ${({ padding_md }) => handlePadding(padding_md, 0, '0px')};
    padding-right: ${({ padding_md }) => handlePadding(padding_md, 1, '40px')};
    padding-bottom: ${({ padding_md }) => handlePadding(padding_md, 2, '0px')};
    padding-left: ${({ padding_md }) => handlePadding(padding_md, 3, '40px')};
  }

  /* Small screens (less than 768px) | default padding 0 16px */
  @media (max-width: ${cpdsMediaQueryVals.cpds_small_upper_limit}) {
    max-width: 100%;
    padding-top: ${({ padding_sm }) => handlePadding(padding_sm, 0, '0px')};
    padding-right: ${({ padding_sm }) => handlePadding(padding_sm, 1, '16px')};
    padding-bottom: ${({ padding_sm }) => handlePadding(padding_sm, 2, '0px')};
    padding-left: ${({ padding_sm }) => handlePadding(padding_sm, 3, '16px')};
  }

  /* Apply styleOverrides if passed */
  ${({ styleOverrides }) => styleOverrides && css`
    ${Object.entries(styleOverrides).map(([key, value]) => {
      if (key.startsWith('@media')) {
        // Handle media queries
        return `
          ${key} {
            ${Object.entries(value as CSSProperties).map(([prop, val]) => `${prop}: ${val};`).join('')}
          }
        `;
      } else {
        // Handle regular CSS properties
        return `${key}: ${value};`;
      }
    }).join('')}
  `}
`;

